// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.wrapper.has-background {
  background: white;
}
.wrapper .country-code {
  width: -moz-fit-content;
  width: fit-content;
  padding: 10px;
  text-align: center;
  font-family: AppFont;
  font-size: 14px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1E1E1C;
  gap: 6px;
  padding-left: 45px;
  padding-top: 15px;
}
.wrapper .country-code.custom {
  color: #8e8e8e;
  font-family: AppFontBold, sans-serif;
}
.wrapper .country-code::after {
  content: "";
  position: absolute;
  right: -4px;
  bottom: -3px;
  height: 50px;
  width: 1px;
  background: #D4D4D4;
}
.wrapper .country-code .flag-container {
  height: 12px;
  width: 20px;
  overflow: hidden;
  margin-right: 10px;
}
.wrapper .country-code .flag-container .flag {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.wrapper .country-code .arrow {
  height: 4px;
  width: 7px;
  margin-left: 13px;
}
.wrapper ion-input {
  padding: 0px 15px !important;
  margin-top: 5px;
  font-family: AppFont, sans-serif;
  color: #1e1e1c;
  font-size: 14px;
}
.wrapper ion-input.custom {
  color: #8e8e8e;
  font-family: AppFontBold, sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/app/components/input-phone-with-county-code/input-phone-with-county-code.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;AACD;AAAC;EACC,iBAAA;AAEF;AAAC;EACC,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;AAEF;AADE;EACC,cAAA;EACA,oCAAA;AAGH;AADE;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AAGH;AAAE;EACC,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAEH;AADG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAGJ;AACE;EACC,WAAA;EACA,UAAA;EACA,iBAAA;AACH;AAEC;EACC,4BAAA;EACA,eAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;AAAF;AACE;EACC,cAAA;EACA,oCAAA;AACH","sourcesContent":[".wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\t&.has-background {\n\t\tbackground: white;\n\t}\n\t.country-code {\n\t\twidth: fit-content;\n\t\tpadding: 10px;\n\t\ttext-align: center;\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcolor: #1E1E1C;\n\t\tgap: 6px;\n\t\tpadding-left: 45px;\n\t\tpadding-top: 15px;\n\t\t&.custom {\n\t\t\tcolor: #8e8e8e;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t}\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tright: -4px;\n\t\t\tbottom: -3px;\n\t\t\theight: 50px;\n\t\t\twidth: 1px;\n\t\t\tbackground: #D4D4D4;\n\t\t}\n\n\t\t.flag-container {\n\t\t\theight: 12px;\n\t\t\twidth: 20px;\n\t\t\toverflow: hidden;\n\t\t\tmargin-right: 10px;\n\t\t\t.flag {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t}\n\n\t\t.arrow {\n\t\t\theight: 4px;\n\t\t\twidth: 7px;\n\t\t\tmargin-left: 13px;\n\t\t}\n\t}\n\tion-input {\n\t\tpadding: 0px 15px !important;\n\t\tmargin-top: 5px;\n\t\tfont-family: AppFont, sans-serif;\n\t\tcolor: #1e1e1c;\n\t\tfont-size: 14px;\n\t\t&.custom {\n\t\t\tcolor: #8e8e8e;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t}\n\t}\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
